import DATA_BROWSER_TABS from '../../models/dataBrowserTabs.js';
class DatabrowserController {
  constructor(dataBrowserService) {
    this.name = 'Data Browser';
    this.ROWS_PER_PAGE = 200;
    this.dataBrowserService = dataBrowserService;
    this.setDefaults('base');
    this.setDefaults('results');
    this.fetchUsersByCustomer();
  }

  setDefaults(tableType) {
    this[tableType] = {
      searchValue: '',
      limit: this.ROWS_PER_PAGE,
      options: DATA_BROWSER_TABS.users[tableType].options,
      columns: DATA_BROWSER_TABS.users[tableType].columns
    };
    this.resetPaginationDefaults(tableType);
    this.resetData(tableType);
  }

  fetchUsersByCustomer() {
    let fetchCriteria = this.getFetchCriteria('base');
    this.dataBrowserService.fetchUsersByCustomer(fetchCriteria)
      .then(this.onFetchDataSuccess.bind(this))
      .catch(this.onFetchDataFailure.bind(this));
  }

  fetchPersonAssignmentsAndAffiliations(resetResults) {
    if (resetResults) {
      this.resetData('results');
      this.resetPaginationDefaults('results');
    }

    let fetchCriteria = this.getFetchCriteria('results');

    if (fetchCriteria.personId) {
      this.dataBrowserService.fetchPersonAssignmentsAndAffiliations(fetchCriteria)
        .then(this.onFetchDataSuccess.bind(this))
        .catch(this.onFetchDataFailure.bind(this));
    }
  }

  getFetchCriteria (tableType) {
    let fetchCriteria = {
      searchValue: this[tableType].searchValue,
      limit: this[tableType].limit,
      offset: this[tableType].offset,
      personId: this.base.options.activeCellData.id,
      role: this.base.options.activeCellData.role
    };
    this.tableType = tableType;
    return fetchCriteria;
  }

  onFetchDataSuccess(data) {
    let tableType = this.tableType;
    
    this.updatedContent = this[tableType].previousData.content.concat(data.data.content.data);

    let updatedData = {
      content: this.updatedContent
    };
    this[tableType].data = updatedData;
    this[tableType].previousData = this[tableType].data;
    this[tableType].offset += this.ROWS_PER_PAGE;
    if (tableType === 'base') {
      this.resetBaseDefaultsAndFetchResults(tableType);

    }
  }

  resetBaseDefaultsAndFetchResults(tableType) {
    let resetResults = true;
    this.resetSearchData(tableType);
    this.setActiveCellData(tableType);
    this.fetchPersonAssignmentsAndAffiliations(resetResults);
  }

  resetSearchData(tableType) {
    this.metaData.entitler.search.errors.NO_SEARCH_RESULTS = this[tableType].data.content.length === 0 ? true : false;
  }

  setActiveCellData(tableType) {
    this[tableType].options.activeCellData = this[tableType].data.content.length > 0 ? this[tableType].data.content[0] : {};
  }

  onFetchDataFailure() {}

  search(tableType) {
    this[tableType].searchValue = this.metaData.entitler.search.value;
    this.resetPaginationDefaults(tableType);
    this.fetchUsersByCustomer();
  }

  resetPaginationDefaults(tableType) {
    this[tableType].offset = 0;
    this[tableType].previousData = {
      content: []
    };
  }

  resetData(tableType) {
    this[tableType].data = {};
  }

  getNextSetOfRowsToFetch(tableFetchMethod) {
    this[tableFetchMethod]();
  }
}

DatabrowserController.$inject = ['dataBrowserService'];
export default DatabrowserController;


// WEBPACK FOOTER //
// ./app/components/dataBrowser/dataBrowser.controller.js